<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">
        Options
        <span class="caret"></span>
      </button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} &amp; exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-if="tab === 'main'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label for="ext-name" class="form-label">Name *</label>
              <input type="text" class="form-control" id="role-name" v-model="entity.name"/>
            </div>
            <div class="form-group">
              <label for="pa-ext" class="form-label">External ID</label>
              <input type="text" class="form-control" id="pa-ext" v-model="entity.externalId"/>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div v-if="entity.id">
              <div class="form-group">
                <label class="form-label">Add Ports to Port Area</label>
                <autocomplete
                  :dataset="ports"
                  title="Port Search"
                  placeHolder="Type to search"
                  :initVal="portAreaLocation"
                  v-on:changing="data => locationSearchText = data"
                  :fnFormatText="displayLocation"
                  :fnSelectValue="displayLocation"
                  v-on:selection-made="selectPort"
                ></autocomplete>
              </div>
              <vue-table
                v-on:table-delete-request="removeLocation"
                :showDelete="true"
                :tableData="portAreaToPorts"
                tableTitle="Ports"
                :fields="[
                { header: 'Port', prop: obj => obj.port ? displayLocation(obj.port) : '' }
                ]"
              ></vue-table>
            </div>
            <div v-else class="mt-20 mb-15">
              <p>Once you have saved the Port Area, you will be able to add Ports</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  import VueTable from '../../../helpers/VueTable.vue'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  import event from '../../../../event'
  export default {
    name: 'PortArea',
    mixins: [AdminEntityMixin, HelperMixin],
    components: {
      Autocomplete,
      VueTable
    },
    data () {
      return {
        shouldUpdateCache: true,
        cachePropertyName: 'portAreas',
        portAreaLocation: null,
        transformForUpdate: {
          externalId: this.toZero
        },
        newEntityScreen: 'Admin - Port Areas',
        editEntityScreen: 'Admin - Edit/View Port Area',
        tab: 'main',
        entity: {
          id: null,
          name: null,
          externalId: null
        },
        entityName: 'port-area',
        boxes: [],
        portAreaToPorts: []
      }
    },
    computed: {
      isValid () {
        return this.entity.name && this.entity.name.trim().length
      },
      storePortAreaToPorts () {
        return this.$store.getters['admin/portAreaToPorts']
      }
    },
    methods: {
      findLocationInPortAreasToPortByIndex (locationsArr, loc) {
        return locationsArr.findIndex(({port}) => port.id === loc.id)
      },
      removeLocation ({ item, index }) {
        const i = this.findLocationInPortAreasToPortByIndex(this.portAreaToPorts, item.port)
        if (item.id) {
          this.deleteRelatedEntity('port-area-to-port', item.id)
          .then(({data}) => {
            event.$emit('toast', { type: 'success', message: 'Port deleted' })
            this.portAreaToPorts.splice(i, 1)
          })
          .catch(err => {
            event.$emit('toast', { type: 'error', message: 'Unable to delete Port; please try again or contact support' })
            console.log(err)
          })
        }
      },
      selectPort (l) {
        if (Object.keys(l).length > 0) {
          if (this.findLocationInPortAreasToPortByIndex(this.portAreaToPorts, l) > -1) {
            event.$emit('toast', { type: 'warning', message: 'PortArea already contains selected location' })
          } else {
            this.saveRelatedEntity('port-area-to-port', {
              id: null,
              portArea: this.entity.id,
              port: l
            }).then(({data}) => {
              event.$emit('toast', { type: 'success', message: 'Port added' })
              this.portAreaToPorts.push(data)
            })
            .catch(err => {
              event.$emit('toast', { type: 'error', message: 'Unable to add Port; please try again or contact support' })
              console.log(err)
            })
          }
        }
        this.locationSearchText = ''
        this.locationSearchResults = []
        this.$nextTick(() => {
          this.portAreaLocation = ''
        })
      },
      getBaseData () {
        return {
          id: null,
          name: null,
          externalId: null
        }
      },
      refresh () {
        this.portAreaToPorts = this.storePortAreaToPorts
      }
    },
    mounted () {
      this.portAreaToPorts = this.storePortAreaToPorts
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// PortArea.vue?00e08fb4